import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import ErpTemplate from '../../components/ErpTemplate';
import { FaArrowLeft, FaQuestion, FaTable, FaUsers, FaChartBar, FaSmile } from 'react-icons/fa';
import api from '../../services/api';
import '../../css/financeiro-parcela-pagar.css';

// Cor da nota no mapa de calor — MESMA fórmula da tela pública (accessfrontcliente).
// Quem viu a escala colorida ao responder reconhece as mesmas cores no resultado.
function corDaNota(valor, min, max) {
    const t = max === min ? 1 : (valor - min) / (max - min);
    const hue = t <= 0.5 ? 4 + t * 2 * 42 : 46 + (t - 0.5) * 2 * 94;
    return `hsl(${Math.round(hue)}, ${t <= 0.5 ? 72 : 62}%, ${t <= 0.5 ? 50 : 38}%)`;
}

const LABEL_TIPO = {
    nota: 'Nota', texto: 'Texto livre', escolha_unica: 'Escolha única', multipla_escolha: 'Múltipla escolha',
};

/**
 * Resultado da pesquisa de satisfação do evento — lê o consolidado do
 * SatisfacaoResultadoService (mesma fonte do PDF). Uma tela por evento:
 * KPIs no topo, depois as seções com cada pergunta renderizada pelo tipo.
 */
export default function ResultadoSatisfacao({ match }) {
    const id = match.params.id;
    const token = localStorage.getItem('token');
    const [dados, setDados] = useState(null);
    const [carregando, setCarregando] = useState(true);
    const [erro, setErro] = useState(null);

    useEffect(() => {
        if (!id) return;
        setCarregando(true);
        api({ method: 'get', action: '/eventoSatisfacaoPergunta/resultado/' + id, token })
            .then(r => { setDados(r.data?.data ?? r.data); setErro(null); })
            .catch(e => setErro(e?.response?.data?.error || 'Não foi possível carregar o resultado.'))
            .finally(() => setCarregando(false));
    }, [id, token]);

    const totais = dados?.totais || {};
    const nps = dados?.nps || null;
    const secoes = dados?.secoes || [];
    const temRespostas = (totais.responderam || 0) > 0;

    return (
        <ErpTemplate>
            <div className="main-content container-fluid fin-pp">

                <div className="fin-pp__head">
                    <div>
                        <h1 className="fin-pp__title">Resultado da Pesquisa de Satisfação</h1>
                        {dados?.evento?.nome && <p className="fin-pp__subtitle">{dados.evento.nome}</p>}
                    </div>
                    <div className="fin-pp__actions">
                        <Link to={'/cadastroEventoSatisfacaoPergunta/' + id} className="fin-pp__btn fin-pp__btn--sm" style={{ textDecoration: 'none' }}>
                            <FaQuestion size={13} style={{ marginRight: 6 }} /> Perguntas
                        </Link>
                        {/* PDF: mesmo formulário POST do modal do Painel do Evento (abre em nova aba) */}
                        <form method="post" action={process.env.REACT_APP_API_URL + '/evento/exportarSatisfacaoPerguntas'} target="_blank" style={{ margin: 0 }}>
                            <input type="hidden" name="token" value={token || ''} />
                            <input type="hidden" name="idEvento" value={id} />
                            <button type="submit" className="fin-pp__btn fin-pp__btn--sm">
                                <FaTable size={13} style={{ marginRight: 6 }} /> PDF
                            </button>
                        </form>
                        <Link to="/evento" className="fin-pp__btn fin-pp__btn--sm" style={{ textDecoration: 'none' }}>
                            <FaArrowLeft size={13} style={{ marginRight: 6 }} /> Eventos
                        </Link>
                    </div>
                </div>

                {carregando && <div className="fin-pp__card" style={{ padding: 24, color: 'var(--fin-mt)' }}>Carregando resultado...</div>}
                {!carregando && erro && <div className="fin-pp__card" style={{ padding: 24, color: 'var(--fin-dg)' }}>{erro}</div>}

                {!carregando && !erro && dados && (<>
                    {/* ── KPIs ─────────────────────────────────────────────── */}
                    <section className="fin-pp__kpis">
                        <div className="fin-pp__kpi">
                            <div className="fin-pp__kpi-top">
                                <span className="fin-pp__kpi-label">Responderam</span>
                                <span className="fin-pp__kpi-ic"><FaUsers size={15} /></span>
                            </div>
                            <div className="fin-pp__kpi-value">{totais.responderam ?? 0}</div>
                            <div className="fin-pp__kpi-sub">
                                {totais.pendentes > 0
                                    ? `${totais.pendentes} participante(s) com e-mail ainda não responderam`
                                    : `de ${totais.participantesComEmail ?? 0} participante(s) com e-mail`}
                            </div>
                        </div>
                        <div className="fin-pp__kpi">
                            <div className="fin-pp__kpi-top">
                                <span className="fin-pp__kpi-label">Perguntas</span>
                                <span className="fin-pp__kpi-ic"><FaChartBar size={15} /></span>
                            </div>
                            <div className="fin-pp__kpi-value">{totais.perguntas ?? 0}</div>
                            <div className="fin-pp__kpi-sub">{secoes.filter(s => s.titulo).length} seção(ões)</div>
                        </div>
                        <div className="fin-pp__kpi">
                            <div className="fin-pp__kpi-top">
                                <span className="fin-pp__kpi-label">NPS</span>
                                <span className="fin-pp__kpi-ic"><FaSmile size={15} /></span>
                            </div>
                            {nps && nps.score !== null ? (<>
                                <div className="fin-pp__kpi-value" style={{ color: nps.score >= 50 ? 'var(--fin-ok)' : nps.score >= 0 ? 'var(--fin-tx)' : 'var(--fin-dg)' }}>
                                    {nps.score > 0 ? '+' : ''}{nps.score}
                                </div>
                                <div className="fin-pp__kpi-sub" title={nps.pergunta}>
                                    {nps.promotores} promotores · {nps.neutros} neutros · {nps.detratores} detratores
                                    {!nps.escalaPadrao && ' · escala fora de 0–10, cálculo proporcional'}
                                </div>
                            </>) : (<>
                                <div className="fin-pp__kpi-value" style={{ color: 'var(--fin-mt)' }}>—</div>
                                <div className="fin-pp__kpi-sub">
                                    {temRespostas
                                        ? 'Nenhuma pergunta marcada como "Indicador NPS"'
                                        : 'Sem respostas ainda'}
                                </div>
                            </>)}
                        </div>
                    </section>

                    {!temRespostas && (
                        <div className="fin-pp__card" style={{ padding: 20, color: 'var(--fin-mt)', marginBottom: 16 }}>
                            Ninguém respondeu ainda. Os resultados aparecem aqui conforme as respostas chegarem.
                        </div>
                    )}

                    {/* ── Seções e perguntas ───────────────────────────────── */}
                    {secoes.map((secao, si) => (
                        <section key={si} className="fin-pp__region" style={{ marginBottom: 18 }}>
                            {secao.titulo && (
                                <div className="fin-pp__cphead">
                                    <div><h2 className="fin-pp__cphead-title">{secao.titulo}</h2></div>
                                </div>
                            )}
                            <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                                {secao.perguntas.map(q => <Pergunta key={q.id} q={q} />)}
                            </div>
                        </section>
                    ))}
                </>)}
            </div>
        </ErpTemplate>
    );
}

function Pergunta({ q }) {
    return (
        <div className="fin-pp__card" style={{ padding: '14px 16px' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', gap: 12, alignItems: 'flex-start', flexWrap: 'wrap' }}>
                <div style={{ flex: 1, minWidth: 240 }}>
                    <div style={{ fontWeight: 600, fontSize: '0.97rem' }}>{q.pergunta}</div>
                    {q.instrucao && <div style={{ fontSize: '0.8rem', color: 'var(--fin-mt)', marginTop: 2 }}>{q.instrucao}</div>}
                </div>
                <span className="fin-pp__pill is-muted" style={{ fontSize: '0.72rem' }}>{LABEL_TIPO[q.tipoResposta] || q.tipoResposta}</span>
            </div>

            {q.tipoResposta === 'nota' && <ResultadoNota q={q} />}
            {q.tipoResposta === 'texto' && <ResultadoTexto q={q} />}
            {(q.tipoResposta === 'escolha_unica' || q.tipoResposta === 'multipla_escolha') && <ResultadoEscolha q={q} />}
        </div>
    );
}

/* Nota: média grande + distribuição em barras coloridas pelo mapa de calor.
   A distribuição importa mais que a média sozinha — duas perguntas com média 7
   podem ser "todo mundo deu 7" ou "metade 10, metade 4", e só a barra mostra. */
function ResultadoNota({ q }) {
    const maxQtd = Math.max(1, ...q.distribuicao.map(d => d.qtd));
    return (
        <div style={{ display: 'flex', gap: 22, marginTop: 12, alignItems: 'flex-start', flexWrap: 'wrap' }}>
            <div style={{ minWidth: 110 }}>
                <div style={{ fontSize: '0.72rem', color: 'var(--fin-mt)', textTransform: 'uppercase', letterSpacing: '.06em' }}>Média</div>
                <div style={{ fontSize: '2rem', fontWeight: 700, lineHeight: 1.1, color: q.media !== null ? corDaNota(q.media, q.notaMin, q.notaMax) : 'var(--fin-mt)' }}>
                    {q.media !== null ? String(q.media).replace('.', ',') : '—'}
                </div>
                <div style={{ fontSize: '0.78rem', color: 'var(--fin-mt)' }}>
                    {q.respondentes} resposta{q.respondentes === 1 ? '' : 's'}
                    {q.naoParticipei > 0 && <> · {q.naoParticipei} não participaram</>}
                </div>
                {q.nps && q.nps.score !== null && (
                    <div style={{ marginTop: 6 }}>
                        <span className="fin-pp__pill is-info" style={{ fontSize: '0.72rem' }}>NPS {q.nps.score > 0 ? '+' : ''}{q.nps.score}</span>
                    </div>
                )}
            </div>
            <div style={{ flex: 1, minWidth: 260 }}>
                <div style={{ display: 'flex', alignItems: 'flex-end', gap: 4, height: 64 }}>
                    {q.distribuicao.map(d => (
                        <div key={d.nota} style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'flex-end', height: '100%' }}
                            title={`Nota ${d.nota}: ${d.qtd} resposta(s)`}>
                            {d.qtd > 0 && <div style={{ fontSize: '0.68rem', color: 'var(--fin-mt)', marginBottom: 2 }}>{d.qtd}</div>}
                            <div style={{
                                width: '100%', borderRadius: 3,
                                height: Math.max(3, Math.round((d.qtd / maxQtd) * 44)),
                                background: corDaNota(d.nota, q.notaMin, q.notaMax),
                                opacity: d.qtd > 0 ? 1 : 0.18,
                            }} />
                        </div>
                    ))}
                </div>
                <div style={{ display: 'flex', gap: 4, marginTop: 3 }}>
                    {q.distribuicao.map(d => (
                        <div key={d.nota} style={{ flex: 1, textAlign: 'center', fontSize: '0.68rem', color: 'var(--fin-mt)' }}>{d.nota}</div>
                    ))}
                </div>
            </div>
        </div>
    );
}

/* Escolhas: barra horizontal por opção, com contagem e %. */
function ResultadoEscolha({ q }) {
    const max = Math.max(1, ...q.opcoes.map(o => o.qtd));
    return (
        <div style={{ marginTop: 12, display: 'flex', flexDirection: 'column', gap: 6 }}>
            {q.opcoes.map(o => (
                <div key={o.opcao} style={{ display: 'grid', gridTemplateColumns: 'minmax(140px, 1fr) 3fr 70px', gap: 10, alignItems: 'center', fontSize: '0.88rem' }}>
                    <span style={{ color: o.qtd > 0 ? 'var(--fin-tx)' : 'var(--fin-mt)' }}>{o.opcao}</span>
                    <div style={{ height: 10, background: '#eef1f6', borderRadius: 99, overflow: 'hidden' }}>
                        <div style={{ height: '100%', width: (o.qtd / max * 100) + '%', background: 'var(--fin-pr, #2f5fa8)', borderRadius: 99, minWidth: o.qtd > 0 ? 6 : 0 }} />
                    </div>
                    <span style={{ textAlign: 'right', fontVariantNumeric: 'tabular-nums', color: 'var(--fin-mt)' }}>
                        <strong style={{ color: 'var(--fin-tx)' }}>{o.qtd}</strong> · {o.pct}%
                    </span>
                </div>
            ))}
            {q.outros && q.outros.length > 0 && (
                <div style={{ fontSize: '0.8rem', color: 'var(--fin-mt)', marginTop: 4 }}>
                    <strong>Outros:</strong> {q.outros.join('; ')}
                </div>
            )}
            <div style={{ fontSize: '0.74rem', color: 'var(--fin-mt)' }}>
                {q.respondentes} respondente{q.respondentes === 1 ? '' : 's'}
                {q.tipoResposta === 'multipla_escolha' && ' · múltipla escolha: a soma dos % pode passar de 100'}
            </div>
        </div>
    );
}

/* Texto livre: as respostas como citações, com quem escreveu. */
function ResultadoTexto({ q }) {
    return (
        <div style={{ marginTop: 12 }}>
            {q.respostas.length === 0 && <div style={{ fontSize: '0.85rem', color: 'var(--fin-mt)' }}>Nenhuma resposta escrita ainda.</div>}
            <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
                {q.respostas.map((r, i) => (
                    <div key={i} style={{ borderLeft: '3px solid var(--fin-brd)', padding: '6px 10px', fontSize: '0.9rem', background: '#fafbfd', borderRadius: 4 }}>
                        {r.texto}
                        {r.participante && <div style={{ fontSize: '0.74rem', color: 'var(--fin-mt)', marginTop: 2 }}>— {r.participante}</div>}
                    </div>
                ))}
            </div>
            {q.vazias > 0 && <div style={{ fontSize: '0.74rem', color: 'var(--fin-mt)', marginTop: 6 }}>{q.vazias} deixaram em branco</div>}
        </div>
    );
}
